import React, { useEffect, useState } from 'react';
import ReactECharts from 'echarts-for-react';
import { useTheme } from "@mui/material";

const PieChart = ({ orders = [], isMobile }) => {
  const theme = useTheme();
  const [options, setOptions] = useState({});

  useEffect(() => {
    // Contar los pedidos por estado
    const statusCounts = {};
    
    orders.forEach(order => {
      const status = order.status;
      if (statusCounts[status]) {
        statusCounts[status] += 1;
      } else {
        statusCounts[status] = 1;
      }
    });
    
    // Convertir a formato para el gráfico
    const data = Object.entries(statusCounts).map(([status, count]) => ({
      name: status,
      value: count
    }));

    // Definir colores según el estado
    const statusColors = {
      // Estados completados (verde)
      'ENTREGADO': '#2ECC71',
      'Entregado': '#2ECC71',
      'DOCUMENTACIÓN RECTIFICADA': '#27AE60',
      'COMPLETADO': '#229954',
      'Completado': '#229954',
      
      // Estados en procesamiento normal (azul)
      'En Procesando': '#3498DB',
      'Procesando': '#3498DB',
      'EN TRÁNSITO': '#2980B9',
      'DISPONIBLE PARA RECOGER EN TIENDA': '#1ABC9C',
      'Awaiting SEUR Shipment': '#34495E',
      'Awaiting SEUR Label': '#34495E',
      'Awaiting SEUR En Procesando': '#34495E',
      
      // Estados pendientes/espera (amarillo/naranja)
      'Pendiente': '#F1C40F',
      'Pendiente de pago': '#F1C40F',
      'En espera': '#F39C12',
      'Borrador': '#D5DBDB',
      
      // Estados con problemas (rojo/naranja fuerte)
      'DEVOLUCIÓN EN CURSO': '#E67E22',
      'APORTAR SOLUCIÓN': '#D35400',
      'INCIDENCIA': '#D35400',
      'Cancelado': '#E74C3C',
      'Reembolsado': '#C0392B',
      'Fallido': '#922B21',
      
      // Por defecto (para estados no especificados)
      'En Proceso': '#3498DB'  // Mantengo este por compatibilidad
    };

    setOptions({
      tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b}: {c} ({d}%)'
      },
      legend: {
        orient: 'horizontal',
        bottom: isMobile ? "auto" : 0,
        top: isMobile ? 300 : "auto",
        left: 'center',
        data: Object.keys(statusCounts)
      },
      series: [
        {
          name: 'Estado de Pedidos',
          type: 'pie',
          radius: ['40%', '60%'],
          center: ['50%', isMobile? 150 : 230],
          top: 0,
          data: data,
          label: {
            show: false,
            position: "center",
          },
          labelLine: {
            show: false,
          },
          emphasis: {
            label: {
              show: true,
              fontSize: "20",
              fontWeight: "bold",
            },
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
          itemStyle: {
            color: function(params) {
              return statusColors[params.name];
            }
          }
        }
      ]
    });
  }, [orders]);

  return (
    <ReactECharts
      option={options}
      style={{ height: "100%", width: "100%" }}
      opts={{ renderer: "svg" }}
    />
  );
};

export default PieChart;
